export default "__VITE_ASSET__aaeca8e4__"